// src/components/molecules/FormFields/TitleInput.js
import React from "react";
import { Typography, Box } from "@mui/material";
import { useTheme } from "styled-components";

const TitleInput = ({ value, onChange, error, disabled }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="body1"
        component="label"
        htmlFor="title"
        sx={{ fontFamily: "basic-sans", color: "white" }}
      >
        What would you like to title your submission?
      </Typography>
      <input
        type="text"
        id="title"
        name="title"
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          width: "100%",
          padding: "10px",
          marginTop: "8px",
          fontFamily: "basic-sans",
          fontWeight: 300,
          backgroundColor: "white",
          borderRadius: "5px",
          border: error ? `1px solid ${theme.colors.red}` : "1px solid #ccc",
        }}
      />
      {error && (
        <Typography
          variant="body2"
          sx={{
            color: theme.colors.red,
            mt: 1,
            fontFamily: "basic-sans",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TitleInput;
